import { h, Component } from 'preact';

import './index.less';

const groupCatalogueHOC = (WrappedComponent) =>
  class extends Component {
    render () {
      const { groupAmalgamFetched } = this.props;

      if (!groupAmalgamFetched) {
        return (
          <div className="group-amalgam-loader-container">
            <div className="loader" />
          </div>
        );
      }

      return <WrappedComponent {...this.props} />;
    }
  };

export default groupCatalogueHOC;
